import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M15.874 10.429h-.66V8.857a.786.786 0 0 0-.785-.786h-1.572V6.5h2.13a1.807 1.807 0 0 0 1.799-1.8v-.33a1.807 1.807 0 0 0-1.8-1.799h-1.901a1.807 1.807 0 0 0-1.8 1.8v3.7H10.5V2.8A1.807 1.807 0 0 0 8.7 1H6.8A1.807 1.807 0 0 0 5 2.8v.33a1.807 1.807 0 0 0 1.8 1.799h2.129V8.07H7.357a.786.786 0 0 0-.786.786V21.13A1.88 1.88 0 0 0 8.441 23h4.903a1.88 1.88 0 0 0 1.87-1.87v-1.273h.66a3.276 3.276 0 0 0 3.269-3.268v-2.892a3.277 3.277 0 0 0-3.269-3.268M12.857 4.37a.23.23 0 0 1 .228-.228h1.901a.23.23 0 0 1 .228.228v.33a.23.23 0 0 1-.228.228h-2.129zM6.571 3.129V2.8a.23.23 0 0 1 .228-.228h1.902a.23.23 0 0 1 .228.228v.558h-2.13a.23.23 0 0 1-.228-.228m1.572 6.514h5.5v.786h-5.5zm0 2.357h5.5v6.286h-5.5zm5.5 9.13a.3.3 0 0 1-.299.299H8.441a.3.3 0 0 1-.298-.299v-1.273h5.5zm3.928-4.541a1.697 1.697 0 0 1-1.697 1.697h-.66V12h.66a1.697 1.697 0 0 1 1.697 1.697z"
    }, null, -1)
  ]))]))
}
export default { render: render }